import { CheckCircle } from "lucide-react";
import { StepProps } from "../../../../views/marketing-pages/channels/voice/types";


export const StepIndicator: React.FC<StepProps> = ({
  isActive,
  isCompleted,
  icon,
  label,
}) => {
  const getIconColor = () => {
    if (isCompleted) return "bg-blue-600 text-white";
    if (isActive) return "bg-blue-600 text-white";
    return "bg-gray-200 text-[#7B7B7B] font-semibold";
  };

  return (
    <div className="flex flex-col items-center">
      <div
        className={`w-12 h-12 rounded-full flex items-center justify-center ${getIconColor()} transition-colors`}
      >
        {isCompleted ? <CheckCircle className="w-6 h-6" /> : icon}
      </div>
      <span className="text-xs mt-2 text-gray-600 text-center max-w-[80px]">
        {label}
      </span>
    </div>
  );
};